<i18n src="@/lang/common.json"></i18n>

<template>
    <div id="globalMessageQueue">
        <div v-for="msg in messages" :key="msg.id"
                :class="['message', 'w3-card', 'w3-padding', 'w3-leftbar', `w3-border-${msg.color}`]">
            <h2 v-if="msg.title !== ''">{{ msg.title }}</h2>
            <p v-html="msg.text"></p>
            <div v-if="msg.timeout === 0" class="w3-right-align">
                <button class="w3-button theme-primary theme-primary-l1-hover"
                        @click="closeMessage(msg)">{{ $t('buttonlabels.OK') }}</button>
            </div>
        </div>
    </div>
</template>

<style scoped>
#globalMessageQueue {
    position: fixed;
    top: 55px;
    right: 10px;
    z-index: 999;
    width: 25%;
}

.message {
    background: #fff;
    margin-bottom: 10px;
}

.message h2 {
    font-size: 1.2em;
    font-weight: bold;
}
</style>

<script>
import moment from 'moment'

import EventBus from '@/util/EventBus'

const DEFAULT_TITLE = '';
const DEFAULT_TEXT = '';
const DEFAULT_COLOR = 'blue';
const DEFAULT_TIMEOUT = 0;

window.toast = (message) => {
    var msg = {
        title: typeof message.title === 'string' ? message.title.trim() : DEFAULT_TITLE,
        text: typeof message.text === 'string' ? message.text.trim() : DEFAULT_TEXT,
        color: typeof message.color === 'string' ? message.color : DEFAULT_COLOR,
        timeout: typeof message.timeout === 'number' ? message.timeout : DEFAULT_TIMEOUT
    }
    EventBus.$emit('global-message', { message: msg })
}

window.clearToasts = () => {
    EventBus.$emit('global-messages-clear')
}

export default {
    data () {
        return {
            possibleColors: ['red', 'green', 'yellow', 'blue'],
            messages: []
        }
    },

    mounted () {
        var self = this

        // Add handler for "global-message" event via EventBus
        EventBus.$on('global-message', event => {
            if (typeof event.message === 'undefined') {
                return
            }
            self.queueMessage(event.message)
        })

        // Add handler for "global-messages-clear" event via EventBus
        EventBus.$on('global-messages-clear', () => {
            self.clear()
        })
    },

    methods: {
        /**
         * Enqueue a new message to be displayed.
         * If the message has a timeout value, it will automatically vanish after this amount of ms. If it has no
         * timeout, an OK button will be displayed instead.
         * @param message The message to be displayed. Must contain the field text. Possible fields are:
         * - title: Set the message title if needed. Optional. Default: Empty string.
         * - message: Set the message. Required.
         * - color: Set the message color, one of (red, green, yellow, blue). Optional. Default: blue.
         * - timeout: Set a timeout in milliseconds after which the message shall disappear automatically. Optional.
         *  Default: 0.
         */
        queueMessage (message) {
            var self = this

            if (typeof message.text !== 'undefined') {
                var msg = {
                    id: moment().format('YYYYMMDDHHmmssSSS'),
                    text: message.text,
                    title: typeof message.title === 'string' ? message.title : '',
                    color: typeof message.color === 'string' && self.possibleColors.includes(message.color) ? message.color : 'blue',
                    timeout: typeof message.timeout === 'number' && message.timeout > 0 ? message.timeout : 0
                }

                self.messages.push(msg)
                if (msg.timeout > 0) {
                    window.setTimeout(() => {
                        self.closeMessage(msg)
                    }, msg.timeout)
                }
            }
        },

        /**
         * Close/remove a given message from the queue.
         * @param message The message to remove from the message queue. If it does not exist, nothing happens.
         */
        closeMessage (message) {
            if (typeof message.id === 'string') {
                this.messages = this.messages.filter(m => m.id !== message.id)
            }
        },

        /**
         * Close/remove all currently displayed messages.
         */
        clear () {
            this.messages = []
        }
    }
}
</script>
